var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.topShow),expression:"topShow"}],staticClass:"me-to-top",on:{"click":_vm.toTop}},[_c('span',{staticClass:"iconfont "},[_vm._v("")])])])}
var staticRenderFns = []

export { render, staticRenderFns }